export default __webpack_public_path__ + "static/media/bgAsset1.222bc71f.svg";